var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9294 2.50001L13.9294 13.5L0.929443 13.5L4.92944 2.5L16.9294 2.50001Z",
    stroke: "#626262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9294 9L7.92944 6L13.4294 1L15.9294 4L10.9294 9Z",
    fill: "#FFD200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92944 9L7.92944 6L10.9294 9L7.92944 9Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92944 6C9.59611 4.5 13.0294 1.4 13.4294 1L15.9294 4L10.9294 9L7.92944 9L7.92944 6Z",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42944 9L7.92944 7.5L7.92944 9L9.42944 9Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorey);
export default __webpack_public_path__ + "static/media/storey.1ca700d4750461677d77a334fc7dbc4b.svg";
export { ForwardRef as ReactComponent };